import { useEffect, useState } from "react";
import "./flashcard.css";
import { Dropdown } from "react-bootstrap";
import { generateCards } from "../../../Redux/flashcards/flashcards.action";
import Loader from "../../../utils/loader/loader";
import ToastMessage from "../../../utils/toasts/toastMessage";
import { useDispatch, useSelector } from "react-redux";
import { getResource } from "../../../Redux/resource/resource.action";
import { useNavigate } from "react-router-dom";
import { getMaterialId } from "../../../utils/utils";

const cardData = [
  {
    chapter: "Motivation 1",
    question: "How should I approach challenges?",
    answer: "Challenges are opportunities in disguise. Keep going! :muscle:",
  },
  {
    chapter: "Motivation 2",
    question: "What if I fail?",
    answer:
      "Failure is not the end — it’s the first step to learning. :seedling:",
  },
  {
    chapter: "Motivation 3",
    question: "Why keep learning?",
    answer:
      "Knowledge is power — every day you learn, you grow stronger. :books:",
  },
];

const FlashcardMain = () => {
  const dispatch = useDispatch();
  const nav = useNavigate();

  const [flippedCards, setFlippedCards] = useState([false, false, false]);
  const [activeSlide, setActiveSlide] = useState(0);
  const [selectedSubject, setSelectedSubject] = useState(null);
  const [selectedChapter, setSelectedChapter] = useState(null);
  const [selectedDifficulty, setSelectedDifficulty] = useState(null);

  const [subjectChapters, setSubjectChapters] = useState(null);

  const [loading, setLoading] = useState(false);
  const [toastState, setToastState] = useState({
    show: false,
    message: "",
    type: "",
  });

  const uploadedResourceStore = useSelector(
    (state) => state?.ResourceManager?.uploadedResource
  );
  const cardsObj = useSelector(
    (state) => state?.FlashCardsManager?.cards?.flashcards
  );
  const cardsSubject = useSelector((state) => state?.FlashCardsManager?.cards);

  // Autoplay: slide every 60 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveSlide((prev) => (prev + 1) % cardData.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    dispatch(getResource());
  }, [dispatch]);

  useEffect(() => {
    if (uploadedResourceStore && uploadedResourceStore.length > 0) {
      const subjectMap = {};

      uploadedResourceStore.forEach((item) => {
        const subject =
          item.subject.charAt(0).toUpperCase() +
          item.subject.slice(1).toLowerCase();
        if (!subjectMap[subject]) {
          subjectMap[subject] = [];
        }
        subjectMap[subject].push(item.chapter);
      });

      setSubjectChapters(subjectMap);
    } else {
      console.log("Error - not getting uploaded resource");
    }
  }, [uploadedResourceStore]);

  const handleShowAnswer = (e, index) => {
    e.preventDefault();
    const updated = [...flippedCards];
    updated[index] = true;
    setFlippedCards(updated);
  };

  const handleCloseAnswer = (e, index) => {
    e.preventDefault();
    const updated = [...flippedCards];
    updated[index] = false;
    setFlippedCards(updated);
  };

  const handleSelectSubject = (e) => {
    const subjectValue = e.target.name;
    if (subjectValue) {
      setSelectedSubject(subjectValue);
    }
  };

  const handleSelectChapter = (e) => {
    const chapterValue = e.target.name;
    if (chapterValue) {
      setSelectedChapter(chapterValue);
    }
  };

  const handleSelectDifficulty = (e) => {
    const difficultyValue = e.target.name;
    if (difficultyValue) {
      setSelectedDifficulty(difficultyValue);
    }
  };

  // const handleGenerate = async (e) => {
  //   e.preventDefault();
  //   if (!selectedSubject || !selectedChapter || !selectedDifficulty) {
  //     setToastState({
  //       show: true,
  //       message: "Select all items.",
  //       type: "error",
  //     });
  //     return;
  //   }
  //   setLoading(true);
  //   const materialId = getMaterialId(
  //     uploadedResourceStore,
  //     selectedSubject,
  //     selectedChapter
  //   );
  //   const payload = {
  //     subject: selectedSubject,
  //     chapter: selectedChapter,
  //     difficulty: selectedDifficulty,
  //     material_id: materialId,
  //   };
  //   try {
  //     const result = await dispatch(generateCards(payload));
  //     if (result) {
  //       setToastState({
  //         show: true,
  //         message: "Questions are generated!",
  //         type: "success",
  //       });
  //       setSelectedSubject(null);
  //       setSelectedChapter(null);
  //       setSelectedDifficulty(null);
  //     }
  //   } catch (error) {
  //     if (error.status === 401) {
  //       setToastState({
  //         show: true,
  //         message:
  //           error.response.data.detail ||
  //           "unable to process request...please try later!",
  //         type: "error",
  //       });
  //       // setTimeout(() => {
  //       //   nav("/");
  //       // }, 1000);
  //       setSelectedSubject(null);
  //       setSelectedChapter(null);
  //       setSelectedDifficulty(null);
  //     } else {
  //       setSelectedSubject(null);
  //       setSelectedChapter(null);
  //       setSelectedDifficulty(null);
  //       setToastState({
  //         show: true,
  //         message: "Something went wrong.",
  //         type: "error",
  //       });
  //     }
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleGenerate = async (e) => {
  e.preventDefault();
  if (!selectedSubject || !selectedChapter || !selectedDifficulty) {
    setToastState({
      show: true,
      message: "Select all items.",
      type: "error",
    });
    return;
  }

  setLoading(true);

  const materialId = getMaterialId(
    uploadedResourceStore,
    selectedSubject,
    selectedChapter
  );

  const payload = {
    subject: selectedSubject,
    chapter: selectedChapter,
    difficulty: selectedDifficulty,
    material_id: materialId,
  };

  const result = await dispatch(generateCards(payload));

  setLoading(false);

  // Reset selections regardless of outcome (matches your original behavior)
  setSelectedSubject(null);
  setSelectedChapter(null);
  setSelectedDifficulty(null);

  if (result.success) {
    setToastState({
      show: true,
      message: "Questions are generated!",
      type: "success",
    });
  } else {
    setToastState({
      show: true,
      message: result.message || "Something went wrong.",
      type: "error",
    });
   
  }
};

  return (
    <section className="w-100 flashcards">
      <h1 className="fz28 fw700 flashcards__title">
        Generate your on flashcards
      </h1>

      <form action="#" className="bdrs40 flashcards__form">
        <Dropdown>
          <Dropdown.Toggle className="dd-code" id="dropdown-type">
            {selectedSubject || "Subject"}
          </Dropdown.Toggle>
          <Dropdown.Menu
            className="p-2 dd-menu"
            onClick={(e) => handleSelectSubject(e)}
          >
            {subjectChapters &&
              Object?.keys(subjectChapters)?.map((d) => (
                <Dropdown.Item value={d} name={d} onClick={handleSelectSubject}>
                  {d}
                </Dropdown.Item>
              ))}
          </Dropdown.Menu>
        </Dropdown>

        <Dropdown>
          <Dropdown.Toggle className="dd-code" id="dropdown-type">
            {selectedChapter || "Chapter"}
          </Dropdown.Toggle>

          <Dropdown.Menu
            className="p-2 dd-menu"
            onClick={(e) => handleSelectChapter(e)}
          >
            {selectedSubject &&
              subjectChapters[selectedSubject]?.map((chapter, index) => (
                <Dropdown.Item value={chapter} name={chapter}>
                  {chapter || "select..."}
                </Dropdown.Item>
              ))}
          </Dropdown.Menu>
        </Dropdown>

        <Dropdown>
          <Dropdown.Toggle className="dd-code" id="dropdown-type">
            {selectedDifficulty || "Difficulty"}
          </Dropdown.Toggle>
          <Dropdown.Menu
            className="p-2 dd-menu"
            onClick={(e) => handleSelectDifficulty(e)}
          >
            <Dropdown.Item value="Easy" name="Easy">
              Easy
            </Dropdown.Item>
            <Dropdown.Item value="Moderate" name="Moderate">
              Moderate
            </Dropdown.Item>
            <Dropdown.Item value="Hard" name="Hard">
              Hard
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>

        <button
          className="btn btn-solid btn-solid--dark fz18"
          onClick={(e) => handleGenerate(e)}
        >
          Generate
        </button>
      </form>

      <h1 className="fz28 fw700 flashcards__title">Flashcards</h1>

      <div className=" flashcards__bottom">
        <div className="bdrs40 slider">
          <div className="d-flex h-100 slider-track">
            {(cardsObj ? cardsObj : cardData)?.map((card, i) => (
              <div
                key={i}
                className={`flip-box slider-item ${
                  activeSlide === i ? "active" : ""
                } ${flippedCards[i] ? "flipped" : ""}`}
              >
                <div className="flip-box-front">
                  <div className="slider__content">
                    <h4 className="fw500 fz24">
                      {`Chapter: ${card.chapter || cardsSubject?.chapter}`}{" "}
                    </h4>
                    <h2 className="fw500 fz44">{card?.question}</h2>
                    <button
                      className={`ms-auto btn btn-solid btn-solid--dark fz18 ${
                        flippedCards[i] ? "btnClicked" : ""
                      }`}
                      onClick={(e) => handleShowAnswer(e, i)}
                    >
                      Show Answer
                    </button>
                  </div>
                </div>
                <div className="flip-box-back">
                  <div className="slider__content">
                    <h4 className="fw500 fz24">Answer :</h4>
                    <h2 className="fw500 fz44"> {card?.answer}</h2>
                    <button
                      className="btn fz18 btn-cross"
                      onClick={(e) => handleCloseAnswer(e, i)}
                    >
                      <img
                        src="./assets/images/inner-pages/icons/icon-close-white-aira-chat.svg"
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Slider dots */}
          <div className="slider-dots">
            {(cardsObj ? cardsObj : cardData)?.map((_, i) => (
              <button
                key={i}
                className={`dot ${activeSlide === i ? "active" : ""}`}
                onClick={(e) => setActiveSlide(e, i)}
              />
            ))}
          </div>
        </div>

        <div className="bdrs40 static-block">
          <div className="static-block__content">
            <h2 className="text-white fz36 fw700">
              Inspiring Minds,Shaping Futures
            </h2>

            <button className="btn fz14 btn-white">Odio ducimus</button>
          </div>
        </div>
      </div>

      <Loader show={loading} />
      <ToastMessage
        show={toastState.show}
        onClose={() => setToastState({ show: false, message: "", type: "" })}
        message={toastState.message}
        type={toastState.type}
      />
    </section>
  );
};

export default FlashcardMain;
